/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_2_Task_Complete_3_FocusInputs */

const en_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete 3 focus sessions`)
};

const ar_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكمل 3 جلسات تركيز`)
};

const de_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Fokus-Sitzungen abschließen`)
};

const es_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa 3 sesiones de concentración`)
};

const fr_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compléter 3 sessions de concentration`)
};

const it_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa 3 sessioni di concentrazione`)
};

const ja_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォーカスを3回完了`)
};

const ko_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 3회 완료하기`)
};

const pt_br_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclua 3 sessões de foco`)
};

const ru_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершите 3 фокусировки`)
};

const th_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โฟกัสให้เสร็จสิ้น 3 ครั้ง`)
};

const tr_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Odaklanma Tamamla`)
};

const zh_cn_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成 3 次专注`)
};

const zh_tw_phase_2_task_complete_3_focus = /** @type {(inputs: Phase_2_Task_Complete_3_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成 3 次專注`)
};

/**
* | output |
* | --- |
* | "Complete 3 focus sessions" |
*
* @param {Phase_2_Task_Complete_3_FocusInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const phase_2_task_complete_3_focus = /** @type {((inputs?: Phase_2_Task_Complete_3_FocusInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_2_Task_Complete_3_FocusInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phase_2_task_complete_3_focus(inputs)
	if (locale === "ar") return ar_phase_2_task_complete_3_focus(inputs)
	if (locale === "de") return de_phase_2_task_complete_3_focus(inputs)
	if (locale === "es") return es_phase_2_task_complete_3_focus(inputs)
	if (locale === "fr") return fr_phase_2_task_complete_3_focus(inputs)
	if (locale === "it") return it_phase_2_task_complete_3_focus(inputs)
	if (locale === "ja") return ja_phase_2_task_complete_3_focus(inputs)
	if (locale === "ko") return ko_phase_2_task_complete_3_focus(inputs)
	if (locale === "pt_br") return pt_br_phase_2_task_complete_3_focus(inputs)
	if (locale === "ru") return ru_phase_2_task_complete_3_focus(inputs)
	if (locale === "th") return th_phase_2_task_complete_3_focus(inputs)
	if (locale === "tr") return tr_phase_2_task_complete_3_focus(inputs)
	if (locale === "zh_cn") return zh_cn_phase_2_task_complete_3_focus(inputs)
	return zh_tw_phase_2_task_complete_3_focus(inputs)
});